var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_387_2413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 50C31.6304 50 37.9893 47.3661 42.6777 42.6777C47.3661 37.9893 50 31.6304 50 25C50 18.3696 47.3661 12.0107 42.6777 7.32233C37.9893 2.63392 31.6304 0 25 0C18.3696 0 12.0107 2.63392 7.32233 7.32233C2.63392 12.0107 0 18.3696 0 25C0 31.6304 2.63392 37.9893 7.32233 42.6777C12.0107 47.3661 18.3696 50 25 50ZM16.0254 31.7871C17.7734 33.8086 20.7617 35.9375 25 35.9375C29.2383 35.9375 32.2266 33.8086 33.9746 31.7871C34.541 31.1328 35.5273 31.0645 36.1816 31.6309C36.8359 32.1973 36.9043 33.1836 36.3379 33.8379C34.1602 36.3379 30.3809 39.0625 25 39.0625C19.6191 39.0625 15.8398 36.3379 13.6621 33.8379C13.0957 33.1836 13.1641 32.1973 13.8184 31.6309C14.4727 31.0645 15.459 31.1328 16.0254 31.7871ZM14.1016 20.3125C14.1016 19.4837 14.4308 18.6888 15.0169 18.1028C15.6029 17.5167 16.3978 17.1875 17.2266 17.1875C18.0554 17.1875 18.8502 17.5167 19.4363 18.1028C20.0223 18.6888 20.3516 19.4837 20.3516 20.3125C20.3516 21.1413 20.0223 21.9362 19.4363 22.5222C18.8502 23.1083 18.0554 23.4375 17.2266 23.4375C16.3978 23.4375 15.6029 23.1083 15.0169 22.5222C14.4308 21.9362 14.1016 21.1413 14.1016 20.3125ZM29.375 22.8125C28.8574 23.5059 27.8809 23.6426 27.1875 23.125C26.4941 22.6074 26.3574 21.6309 26.875 20.9375C29.8438 16.9824 35.7812 16.9824 38.75 20.9375C39.2676 21.6309 39.1309 22.6074 38.4375 23.125C37.7441 23.6426 36.7676 23.5059 36.25 22.8125C34.5312 20.5176 31.0937 20.5176 29.375 22.8125Z",
    fill: "#41BBC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_387_2413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.60d9c44fa460e6e9c9c86a87e5a386b4.svg";
export { ForwardRef as ReactComponent };